<template>
  <div class="login_container">
    <div class="login_box">

      <!-- Logo区 -->
      <div class="logo_area">
        <img src="../assets/logo.png" />
        <h2>Email Verification</h2>
        <p>Please enter the verification code</p>
      </div>

      <!-- 表单 -->
      <el-form class="verify_form">

        <el-form-item>
          <el-input
            v-model="email"
            disabled
            placeholder="Email"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="code"
            placeholder="6-digit verification code"
            autofocus
          />
        </el-form-item>

        <el-form-item class="btns">

          <el-button
            type="primary"
            class="main_btn"
            @click="verify"
          >
            Verify
          </el-button>

          <el-button
            class="sub_btn"
            :disabled="countdown > 0"
            @click="resend"
          >
            {{ countdown > 0 ? countdown + 's' : 'Resend Code' }}
          </el-button>

          <div class="extra">
            <span @click="$router.push('/login')">Back to Login</span>
          </div>

        </el-form-item>

      </el-form>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      code: "",
      countdown: 0,
      timer: null
    };
  },

  created() {
    this.email = this.$route.query.email || "";
    // ⭐ 从 sessionStorage 取密码
  },

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  },

  methods: {
    async verify() {
      try {
        const res = await this.$http.post("/verify_email", {
          email: this.email,
          code: this.code
        });

        // ⭐ 成功弹窗（关键）
        this.$alert("Email verification successful! Please log in.", "Success", {
          confirmButtonText: "OK",
          type: "success",
          callback: () => {

            // ⭐ 跳转登录页
            this.$router.push({
              path: "/login",
              query: { email: this.email }
            });
          }
        });

      } catch (err) {
        const msg = err.response?.data?.msg || "Verification failed";
        this.$message.error(msg);
      }
    },

    async resend() {
      if (this.countdown > 0) return;

      try {
        await this.$http.post("/resend_code", {
          email: this.email
        });

        this.$message.success("Verification code sent");

        this.countdown = 60;

        this.timer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);

      } catch (err) {
        const msg = err.response?.data?.msg || "Failed to send verification code";
        this.$message.error(msg);
      }
    }
  }
};
</script>

<style lang="less" scoped>

/* ===== 页面整体 ===== */
.login_container {
  height: 100%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* ===== 卡片 ===== */
.login_box {
  width: 380px;
  padding: 40px 40px 30px;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
}

/* ===== Logo区 ===== */
.logo_area {
  text-align: center;
  margin-bottom: 30px;

  img {
    width: 48px;
    margin-bottom: 10px;
  }

  h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #1f2a44;
  }

  p {
    margin-top: 6px;
    font-size: 13px;
    color: #6b7280;
  }
}

/* ===== 输入框 ===== */
.el-input__inner {
  border-radius: 6px;
}

/* ===== 主按钮 ===== */
.main_btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 6px;
  background: linear-gradient(90deg, #3fae9a, #6fd1c2);
  border: none;
}

/* ===== 次按钮（验证码） */
.sub_btn {
  width: 100%;
  margin-top: 10px;
  border-radius: 6px;
}

/* ===== 底部操作 ===== */
.extra {
  margin-top: 12px;
  text-align: center;
  font-size: 12px;
  color: #6b7280;

  span {
    cursor: pointer;
  }

  span:hover {
    color: #3fae9a;
  }
}

/* ===== 按钮区 ===== */
.btns {
  display: flex;
  flex-direction: column;
}

/* ===== 图标 ===== */
.iconfont {
  color: #9ca3af;
}

</style>